export default __webpack_public_path__ + "static/media/close-black.8b257a2f.svg";